import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

const CoachingTemplate: TemplateOnlyComponent = <template>
  {{pageTitle "Coaching"}}
  {{outlet}}
</template>;

export default CoachingTemplate;
